<template>
   <div class="all_form_block" data-name="job-stack">
      <div class="block">
         <div class="name_tools" id="job-stack">{{ $store.getters.cv_t('job_stack') }}</div>
         <div class="all_form">
            <div class="inp_info">
               <ul>
                  <template v-for="jobStack in jobStacks">
                     <li
                         v-for="translation in jobStack.translations"
                         :key="translation.id"
                         @click="selectJobStack(jobStack.id, translation.title, $event)"
                         class="job-stack"
                     >
                        <span>{{ translation.title }}</span>
                     </li>
                  </template>
               </ul>
            </div>
         </div>
      </div>
      <div class="edit_block_form inp_info" v-if="$store.state.cv.jobStack.id">
         <div class="tab_menu">
            <ul>
               <li v-for="currency in currencies">
                 <span :class="{active : $store.state.cv.jobStackCurrency.id === currency.id }" class="center_currency"
                       @click="selectCurrency(currency)">
                   {{currency.symbol}}
                 </span>
               </li>
            </ul>
         </div>
         <div class="div_relative">
            <div class="close" @click="reset()"></div>
            <div class="roller">
               <div class="name_number w90">
                  <div class="name_roller">
                     <p>
                        {{$store.state.cv.jobStack.title}}
                        <strong>/{{$store.getters.cv_t("monthly")}}</strong>
                     </p>
                  </div>
                  <div class="number_roller">
                     <template v-if="$store.state.cv.jobStack.sallery">
                        {{ $parent.$parent.XFormatPrice($store.state.cv.jobStack.sallery) }}
                        <strong v-if="plus()">+</strong>
                        <strong>{{ $store.state.cv.jobStackCurrency.symbol}}</strong>
                     </template>
                     <template v-else>
                        {{ $store.getters.cv_t('contractual')}}
                     </template>
                  </div>
               </div>
               <input type="hidden" name="job_stack" v-model="$store.state.cv.jobStack.id">
               <vue-slider
                   v-model="$store.state.cv.jobStack.sallery"
                   :min="0"
                   :max="$store.state.cv.jobStackCurrency.max"
                   :interval="$store.state.cv.jobStackCurrency.step"
               />
            </div>
         </div>
      </div>
   </div>
</template>
<script>
  import VueSlider from "vue-slider-component";

  export default {
    components: {
      VueSlider
    },
    data() {
      return {
        settings: {
          am: {
            max: 500000,
            step: 1000
          },
          ru: {
            max: 200000,
            step: 500
          },
          en: {
            max: 20000,
            step: 25
          }
        },
        jobStacks: [],
        currencies: [],
      };
    },
    watch: {
      "$parent.jobStacks"(to, from) {
        this.jobStacks = to;
        this.translate();
      },
      "$parent.currencies"(to, from) {
        this.currencies = to;
        if (this.$store.state.cv.jobStackCurrency.id === 0) {
          this.$store.commit("jobStackCurrency", this.currencies[0]);
        }
      },
    },
    methods: {
      plus() {
        return (this.$store.state.cv.jobStackPlus = (
          this.$store.state.cv.jobStackCurrency.max ===
          this.$store.state.cv.jobStack.sallery
        ));
      },
      translate() {
        if (this.$store.state.cv.jobStack.id) {
          this.jobStacks.forEach(item => {
            if (this.$store.state.cv.jobStack.id === item.id) {
              this.$store.state.cv.jobStack.title = item.translations[0].title;
            }
          });
        }
      },
      getJobStacks(callBack = false) {
        this.$http({
          url: "/api/cv/job-stack",
          method: "post"
        }).then(res => {
          this.jobStacks = res.data.jobStacks;
          if (callBack) {
            callBack(true);
          }
        });
      },
      selectCurrency(currency) {
        this.$store.commit("jobStackCurrency", currency);
        // this.jobStacks.sallery = 0;
        this.$store.state.cv.jobStack.sallery = 0;
        // this.$store.commit("jobStack", data);
      },
      selectJobStack(id, title, event) {
        var data = {};
        var active = event.target.closest("li").classList.contains("active");
        var li = document.querySelectorAll(".job-stack.active");
        if (li.length) {
          li[0].classList.remove("active");
        }
        if (!active) {
          data = {
            id: id,
            title: title,
            sallery: 0
          };
          event.target.closest("li").classList.add("active");
        } else {
          event.target.closest("li").classList.remove("active");
        }
        this.currencies = this.$parent.currencies;
        this.$store.commit("jobStack", data);
      },
      reset() {
        var li = document.querySelectorAll(".job-stack.active");
        if (li.length) {
          li[0].classList.remove("active");
        }
        this.$store.commit("jobStack", {});
      }
    }
  };
</script>

<style scoped>
   .center_currency{
      line-height: 40px;
   }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/JobStack.vue